import GetBusinessPartnerInfoLogic from "../Application/GetBusinessPartnerInfo.logic";
import {setBusinessPartnerModel} from "./BusinessPartner.reducer";
import store from "../../Redux/store";

export default async function GetBusinessPartnerInfo(id) {
  const info = await GetBusinessPartnerInfoLogic(id);
  store.dispatch( setBusinessPartnerModel( info ) );
}